import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { z } from 'zod';
import { apiFetch, apiFetchEmpty } from './client';
import { invalidateCommunityAudit } from './communityAudit';

const SuppliersMapSchema = z.record(z.string(), z.string());

export function useCommunitySuppliers(communityId: string | undefined) {
  return useQuery({
    queryKey: ['communities', communityId, 'suppliers'],
    enabled: !!communityId,
    queryFn: () =>
      apiFetch(`/api/communities/${communityId}/suppliers`, SuppliersMapSchema),
  });
}

export function useSaveCommunitySuppliers(communityId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (suppliers: Record<string, string>) =>
      apiFetchEmpty(`/api/communities/${communityId}/suppliers`, {
        method: 'POST',
        body: JSON.stringify({ suppliers }),
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['communities', communityId, 'suppliers'] });
      void qc.invalidateQueries({ queryKey: ['communities', communityId ?? '', 'bid'] });
      invalidateCommunityAudit(qc, communityId);
    },
  });
}
